module.exports = __webpack_public_path__ + "img/strip_head_b.30f04c17.jpg";